// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 725 ? "react-syntax-highlighter/refractor-import" : chunkId) + "." + {"38":"658acadb","313":"be4768cc","453":"d4dd132d","725":"1354ec5d"}[chunkId] + ".chunk.js";
};